import { sdkLogger } from '../../logger/logger';
import type { EndPageMatchType } from '../endPages/resolveEndPageId';
import type { SkipTarget } from '../types';

export function logSkipLogicMatch(
  questionId: string,
  skipLogicId: string,
  targetType: string,
  fromPageIndex: number
): void {
  sdkLogger.info('Skip logic matched', { questionId, skipLogicId, targetType, fromPageIndex });
}

export function logDisplayLogicMatch(
  questionId: string,
  pageIndex: number,
  triggerQuestionId?: string
): void {
  sdkLogger.info('Display logic matched', { questionId, pageIndex, triggerQuestionId });
}

export function logAnswerLogicMatch(
  questionId: string,
  entityType: 'option' | 'row' | 'column',
  entityId: string,
  pageIndex: number,
  triggerQuestionId?: string
): void {
  sdkLogger.info('Answer logic matched', {
    questionId,
    entityType,
    entityId,
    pageIndex,
    triggerQuestionId,
  });
}

export function logQuestionVariantMatch(
  questionId: string,
  variantId: string,
  variantText: string,
  triggerQuestionId?: string
): void {
  sdkLogger.info('Question variant matched', {
    questionId,
    variantId,
    variantText,
    triggerQuestionId,
  });
}

export function logEndPageLogicMatch(
  endPageId: string,
  matchType: EndPageMatchType,
  previousEndPageId?: string,
  triggerQuestionId?: string
): void {
  sdkLogger.info('End page logic matched', {
    endPageId,
    matchType,
    previousEndPageId,
    triggerQuestionId,
  });
}

export function logOriginSkipTarget(
  questionId: string,
  skipTarget: SkipTarget,
  fromPageIndex: number
): void {
  if (skipTarget.type === 'END_OF_SURVEY') {
    logSkipLogicMatch(questionId, skipTarget.skipLogicId, 'END_OF_SURVEY', fromPageIndex);
    return;
  }
  logSkipLogicMatch(questionId, skipTarget.skipLogicId, 'QUESTION', fromPageIndex);
}

export function logSkipLogicRejected(
  questionId: string,
  skipLogicId: string,
  reason: string
): void {
  sdkLogger.warn('Skip logic rejected', { questionId, skipLogicId, reason });
}
